import clsx from "classnames";
import classes from "./styles.module.scss";
import { decode } from "html-entities";
import Link from 'next/link';

export default function JobCard({ job, className, compact }) {
  const tags = job.categories.find((item) => item.name == "Specialisms");
  const jobType = job.categories.find((item) => item.name == "Contract Type");

  return (
    <div className={clsx(className, classes.card, compact && classes.compact)}>
      <div className={classes.job_info}>
        <div className={classes.type}>{jobType?.values[0]?.name}</div>
        <div className={classes.job_info}>
          <Link href={"/jobs/" + job.url_slug} passHref>
            <div className={classes.title}>{job.title}</div>
          </Link>
          <div className={classes.tag}>
            {tags?.values?.map((tag, index) => {
              return( 
                <div key={index} className={classes.tag_item}>{tag.name}</div>
              )
            })}
          </div>
        </div>

        <div className={classes.job_details}>
          <div className={classes.job_location}>
            <img alt="job location" className={classes.icon} src="/icons/location.svg"></img>{job.addresses[0]}
          </div>
          <div className={classes.job_salary}>
            <img alt="job salary" className={classes.icon} src="/icons/credit-card.svg"></img>{job.salary_package}
          </div>
        </div>

        <div className={classes.job_description}>
          <p>{decode(job?.description).replace(/(<([^>]+)>)/ig, " ").split(" ").splice(0, compact ? 25 : 50).join(" ").concat("...")}</p>
        </div>
      </div>
      
      <Link href={"/jobs/" + job.url_slug} passHref>
        <button className={classes.view_btn}>View job</button>
      </Link>
    </div>
  );
}

JobCard.defaultProps = {
  className: "",
  compact: false,
};
